import(/* webpackMode: "eager" */ "/app/src/app/tools/column-summary/page.tsx");
